import React, { useState } from 'react'
import classNames from "classnames";
import "./styles.css";
import {
  daysOfWeek,
  daysOfWeekMobile,
  createDaysForCurrentMonth,
  createDaysForNextMonth,
  createDaysForPreviousMonth,
  isWeekendDay,
  getMonthDropdownOptions,
  getYearDropdownOptions
} from "./helpers";
import GenerateModal from './generate-modal'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import MyImage from '../../components/myImage';
import moment from 'moment'
import { Box } from '@mui/material';
import MyModal from '../../components/myModal';
import MyDialog from '../../components/myDialog';
import MyLabel from '../../components/myLabel';
import MyButton from '../../components/myButton';
import CHANNELS from '../../components/ayrshare/channels';
import SocialIcon from '../../components/ayrshare/socialIcons';
import MyCheckbox from '../../components/myCheckbox';

import twitter from "../../assets/imgs/socials/tags/twitter-opacity.svg";
import linkedin from "../../assets/imgs/socials/tags/linkedin-opacity.svg";
import fbg from "../../assets/imgs/socials/tags/fbg-opacity.svg";
import instagram from "../../assets/imgs/socials/tags/instagram-opacity.svg";
import facebook from "../../assets/imgs/socials/tags/facebook-opacity.svg";
import useAutoAdFromProductDescriptionState from '../../hooks/ayrshare/useAutoAdFromProductDescriptionState';


const imgsMapped = {
  twitter,
  linkedin,
  fbg,
  instagram,
  facebook
}

const RenderDay = ({ calendarDayObject, daysSelected, mobilePosts, mobilePostsActive, setMobilePostsActive, channelsFiltered, handleSelectOneChannel }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [modal, setModal] = useState(0)
  const [dialogOpen, setDialogOpen] = useState(false)
  const isToday = moment().format('YYYY-MM-DD') === moment(calendarDayObject.dateString).format('YYYY-MM-DD')
  const isAfter = moment(calendarDayObject.dateString).isAfter(moment())


  const closeModal = () => {
    setDialogOpen(true)
  }

  const mobilePostsFiltered = mobilePosts.filter(({channel:ch, date}) => {
    return date === calendarDayObject.dateString
  }).map(({date}) => date)

  

  const isCurrentDayClicked = mobilePostsActive === calendarDayObject.dateString
  return (

    <div style={{ height: '100px' }} onClick={() => setMobilePostsActive(calendarDayObject.dateString)}>
      <CalendarDayHeader calendarDayObject={calendarDayObject} isCurrentDayClicked={isCurrentDayClicked} />
      <Box sx={{ display: 'grid', gridGap: 2, marginLeft: '0.8rem', gridTemplateColumns: '1fr 1fr 1fr 1fr' }}>
        {(isAfter || isToday) && window.innerWidth > 600 && channelsFiltered.map((channel, key) => (<div key={key} style={{ cursor: 'pointer' }} onClick={() => {
          if (daysSelected[channel.title]?.includes(calendarDayObject.dateString)) {
            handleSelectOneChannel({ channel: channel.title, date: calendarDayObject.dateString }, true)
          } else {
            handleSelectOneChannel({ channel: channel.title, date: calendarDayObject.dateString }, false)
          }

        }}>
          {window.innerWidth > 600 && <SocialIcon icon={channel.icon} linked={daysSelected[channel.title]?.includes(calendarDayObject.dateString)} sx={{
          width: '15px',
          height: '15px',
          opacity: !daysSelected[channel.title]?.includes(calendarDayObject.dateString) && '0.6'
        }} />
      }
      
        </div>))}
        {window.innerWidth < 600 && mobilePostsFiltered.includes(calendarDayObject.dateString) && !isCurrentDayClicked &&
         
          <FiberManualRecordIcon sx={{width:'12px', color:'#721384', position:'relative', bottom: '1rem', left:'0.4rem', opacity:'0.8' }} />
       
        }
        
      </Box>


    </div>


  )
}

export function CalendarDayHeader({ calendarDayObject, isCurrentDayClicked }) {
  return isCurrentDayClicked && window.innerWidth < 600 ? (<div className={"day-grid-item-header-today"} style={{color: 'white', backgroundColor:'#721384'}}>{calendarDayObject.dayOfMonth}</div>) : <div className="day-grid-item-header-2">{calendarDayObject.dayOfMonth}</div>
}

export default function AutocompleteCalendar({ month, year, autoCompleteOpen, setAutoCompleteOpen, profileSelected }) {

  
  const [mobilePosts, setMobilePosts] = useState([])
  const [mobilePostsActive, setMobilePostsActive] = useState(false)
  const [selectedAllSocials, setSelectedAllSocials] = useState([])
  const [daysSelected, setDaysSelected] = useState({})
  const [selectedOneChannels, setSelectedOneChannels] = useState([])
  const [yearAndMonth, setYearAndMonth] = useState([year, month]);
  const [generateModal, setGenerateModal] = useState(false)
  const today = moment().format('YYYY-MM-DD')

  const close = () => {setGenerateModal(false);setAutoCompleteOpen(false);}

  const state = useAutoAdFromProductDescriptionState(close);

  let currentMonthDays = createDaysForCurrentMonth(yearAndMonth[0], yearAndMonth[1]);
  let previousMonthDays = createDaysForPreviousMonth(
    yearAndMonth[0],
    yearAndMonth[1],
    currentMonthDays
  );

  let nextMonthDays = createDaysForNextMonth(yearAndMonth[0], yearAndMonth[1], currentMonthDays);
  let calendarGridDayObjects = [
    ...previousMonthDays,
    ...currentMonthDays,
    ...nextMonthDays
  ];

  const handleMonthSelect = (evt) => {

    let nextYear = yearAndMonth[0];
    let nextMonth = parseInt(evt.target.value, 10);

    setYearAndMonth([nextYear, nextMonth]);
  };

  const handleYearSelect = (evt) => {
    let nextMonth = moment().year() == evt.target.value && parseInt(yearAndMonth[1]) <= parseInt(moment().month()) ? moment().month() + 1 : yearAndMonth[1];
    let nextYear = parseInt(evt.target.value, 10);
    setYearAndMonth([nextYear, nextMonth]);
  };

  const channelsFiltered = CHANNELS.filter((channel) => channel.active)
  const daysOfWeekFormatted = window.innerWidth < 600 ? daysOfWeekMobile : daysOfWeek

  const handleSelectOneChannel = (channel, remove) => {

    if (remove) {
      daysSelected[channel.channel] = daysSelected[channel.channel]?.filter((date) => date !== channel.date)

      setDaysSelected(daysSelected)
      setSelectedOneChannels([...selectedOneChannels.filter((selected) => JSON.stringify(selected) !== JSON.stringify(channel))])
    } else {
      if (daysSelected[channel?.channel]) {
        daysSelected[channel.channel] = [...daysSelected[channel.channel], channel.date]
      } else {
        daysSelected[channel.channel] = [channel.date]
      }
      setSelectedOneChannels([...selectedOneChannels.filter((selected) => JSON.stringify(selected) !== JSON.stringify(channel))])
      setDaysSelected(daysSelected)
    }

  }
  const handleSelectAllChannelDays = (channel) => {
    const currentMonthDaysFormatted = currentMonthDays.map(({ dateString }) => dateString)
    switch (channel) {
      case 'facebook':
        if (Object.keys(daysSelected).includes('facebook') && daysSelected['facebook'].length) {
          const currentDaysSome = daysSelected['facebook'].some((day) => currentMonthDaysFormatted.includes(day))
          if (currentMonthDaysFormatted.length !== daysSelected['facebook'].length) {
            daysSelected['facebook'] = currentMonthDaysFormatted
          }
          else if (currentDaysSome) {
            daysSelected['facebook'] = daysSelected['facebook'].filter((day) => !currentMonthDaysFormatted.includes(day))
          } else {
            
            daysSelected['facebook'] = daysSelected['facebook'].concat(currentMonthDaysFormatted)
          }



        } else {
          daysSelected['facebook'] = currentMonthDaysFormatted
          setDaysSelected(daysSelected)
        }
        return
      case 'instagram':
        if (Object.keys(daysSelected).includes('instagram') && daysSelected['instagram'].length) {
          const currentDaysSome = daysSelected['instagram'].some((day) => currentMonthDaysFormatted.includes(day))
          if (currentMonthDaysFormatted.length !== daysSelected['instagram'].length) {
            daysSelected['instagram'] = currentMonthDaysFormatted
          }
          else if (currentDaysSome) {
            daysSelected['instagram'] = daysSelected['instagram'].filter((day) => !currentMonthDaysFormatted.includes(day))
          } else {
            
            daysSelected['instagram'] = daysSelected['instagram'].concat(currentMonthDaysFormatted)
          }



        } else {
          daysSelected['instagram'] = currentMonthDaysFormatted
          setDaysSelected(daysSelected)
        }
        return

      case 'fbg':
        if (Object.keys(daysSelected).includes('fbg') && daysSelected['fbg'].length) {
          const currentDaysSome = daysSelected['fbg'].some((day) => currentMonthDaysFormatted.includes(day))
          if (currentMonthDaysFormatted.length !== daysSelected['fbg'].length) {
            daysSelected['fbg'] = currentMonthDaysFormatted
          }
          else if (currentDaysSome) {
            daysSelected['fbg'] = daysSelected['fbg'].filter((day) => !currentMonthDaysFormatted.includes(day))
          } else {
            
            daysSelected['fbg'] = daysSelected['fbg'].concat(currentMonthDaysFormatted)
          }



        } else {
          daysSelected['fbg'] = currentMonthDaysFormatted
          setDaysSelected(daysSelected)
        }
        return

      case 'linkedin':
        if (Object.keys(daysSelected).includes('linkedin') && daysSelected['linkedin'].length) {
          const currentDaysSome = daysSelected['linkedin'].some((day) => currentMonthDaysFormatted.includes(day))
          if (currentMonthDaysFormatted.length !== daysSelected['linkedin'].length) {
            daysSelected['linkedin'] = currentMonthDaysFormatted
          }
          else if (currentDaysSome) {
            daysSelected['linkedin'] = daysSelected['linkedin'].filter((day) => !currentMonthDaysFormatted.includes(day))
          } else {
            
            daysSelected['linkedin'] = daysSelected['linkedin'].concat(currentMonthDaysFormatted)
          }



        } else {
          daysSelected['linkedin'] = currentMonthDaysFormatted
          setDaysSelected(daysSelected)
        }
        return

      case 'twitter':
        if (Object.keys(daysSelected).includes('twitter') && daysSelected['twitter'].length) {
          const currentDaysSome = daysSelected['twitter'].some((day) => currentMonthDaysFormatted.includes(day))
          if (currentMonthDaysFormatted.length !== daysSelected['twitter'].length) {
            daysSelected['twitter'] = currentMonthDaysFormatted
          }
          else if (currentDaysSome) {
            daysSelected['twitter'] = daysSelected['twitter'].filter((day) => !currentMonthDaysFormatted.includes(day))
          } else {
            
            daysSelected['twitter'] = daysSelected['twitter'].concat(currentMonthDaysFormatted)
          }



        } else {
          daysSelected['twitter'] = currentMonthDaysFormatted
          setDaysSelected(daysSelected)
        }
        return

    }
  }

  
  return (
    state.isGenerateModal.value ? 
      window.innerWidth < 600 ? <MyDialog 
        fullScreen={window.innerWidth < 600}
        notClose={true} 
        sx={{ position: 'absolute', overflow: 'auto', height: state.isGenerateModal.value ? window.innerWidth < 600 ? '500px' : '100vh' : '800px', left: state.isGenerateModal.value ? window.innerWidth < 600 ? '12%' : '35%' : window.innerWidth < 600 ? '6%' : '22%', top: window.innerWidth > 600 ? state.isGenerateModal.value ? '35%' : '15%' : state.isGenerateModal.value ? '25%' : '15%', width: state.isGenerateModal.value ? window.innerWidth < 600 ? 300 : 550 : window.innerWidth < 600 ? 340 : 850,
        '@media (max-width: 600px)': {
          height:'50vh',
          top:'14rem'
      }}} 
        title="Post" 
        isOpen={autoCompleteOpen} 
        setIsOpen={() => setGenerateModal(false)}> 
          <GenerateModal 
            daysSelected={daysSelected} 
            state={state}
            profileSelected={profileSelected}
            /> 
      </MyDialog> : <MyModal 
        fullScreen={window.innerWidth < 600}
        notClose={true} 
        sx={{ position: 'absolute', overflow: 'auto', height: state.isGenerateModal.value ? window.innerWidth < 600 ? '500px' : '100vh' : '800px', left: state.isGenerateModal.value ? window.innerWidth < 600 ? '12%' : '35%' : window.innerWidth < 600 ? '6%' : '22%', top: window.innerWidth > 600 ? state.isGenerateModal.value ? '35%' : '15%' : state.isGenerateModal.value ? '25%' : '15%', width: state.isGenerateModal.value ? window.innerWidth < 600 ? 300 : 550 : window.innerWidth < 600 ? 340 : 850,
        '@media (max-width: 600px)': {
          height:'50vh',
          top:'14rem'
      }}} 
        title="Post" 
        isOpen={autoCompleteOpen} 
        setIsOpen={() => setGenerateModal(false)}> 
          <GenerateModal 
            daysSelected={daysSelected} 
            state={state}
            profileSelected={profileSelected}
            /> 
      </MyModal>
    : 
      window.innerWidth < 600 ? <MyDialog 
      fullScreen={window.innerWidth < 600}
        notClose={true} 
        sx={{ position: 'absolute', height:'100vh', overflow: 'auto', left: '15%', top: window.innerWidth < 600 && '2rem',  width: window.innerWidth < 600 ? '95vh' : '70vw',
              '@media (max-width: 600px)': {
                width: '100vw',
                left: '0',
                
                float: 'left',
                height:'90vh',
                overflow:'auto'
            }
    }} title="Post" isOpen={autoCompleteOpen} setIsOpen={() => setAutoCompleteOpen(false)}>

      {
        generateModal &&  <MyDialog 
        fullScreen={window.innerWidth < 600}
                              notClose={true} 
                              sx={{ position: 'absolute', overflow: 'auto', height: state.isGenerateModal.value ? window.innerWidth < 600 ? '500px' : '300px' : '100%', left: state.isGenerateModal.value ? window.innerWidth < 600 ? '0' : '32%' : window.innerWidth < 600 ? '0' :'20%', top: window.innerWidth > 600 ? '10%' : state.isGenerateModal.value ? '15%' : '1rem', width: state.isGenerateModal.value ? window.innerWidth < 600 ? 300 : 550 : window.innerWidth < 600 ? '100%' :'60vw', }} 
                              title="Post" 
                              isOpen={autoCompleteOpen} 
                              setIsOpen={() => setGenerateModal(false)}> 
                              <GenerateModal 
                                setIsGenerateModal={state.isGenerateModal.value} 
                                daysSelected={daysSelected} 
                                state={state}
                                profileSelected={profileSelected}
                                /> 
                          </MyDialog>
       }
      

      <div className="calendar-root-autocomplete" >
        <div className="navigation-header" style={{bottom:window.innerWidth > 600 && '1rem', position:'relative'}}>

          <Box sx={{ display: 'flex', margin:0, flexDirection: 'row', justifyContent:'space-around', width: '100%',
          '@media (max-width: 600px)': {
            width: '350px',
            justifyContent: 'left',
            flexWrap:'wrap'
        }
         }}>
            {
              channelsFiltered.map((channel, key) => {
                let sx = { height: '40px', width: '40px' };

                if (!channel.active) {
                  sx = { ...sx, opacity: '0.3' };
                }

                return (
                  <Box sx={{ margin: 0, position: 'relative' }} key={key}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', }}>
                      <SocialIcon sx={{ 
                        width:'25px', 
                     }} icon={channel.icon} linked={true} />
                      <MyImage sx={{ marginLeft: '20px', 
                     width:'60px', 
                    '@media (max-width: 600px)': {
                      width:'35px', 
                      
                  }}} src={imgsMapped[channel.title]} />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', marginLeft: '5px', width:'100%', position: 'relative', bottom: '5px', }}>
                      
                        <MyCheckbox
                          
                          size='small'
                          checked={currentMonthDays.map(({ dateString }) => dateString).every((day) => {
                            return daysSelected[channel.title]?.includes(day) || moment(day).isBefore(today)
                          })}
                          value={null}
                          onChange={(e) => {
                            
                            handleSelectAllChannelDays(channel.title)
                            if (selectedAllSocials.includes(channel.title)) {
                              setSelectedOneChannels([...selectedOneChannels.filter((selectedOneChannel) => selectedOneChannel.channel !== channel.title)])
                              setMobilePosts([...mobilePosts.filter((mobilePost) => mobilePost.channel !== channel.title)])
                              setSelectedAllSocials([...selectedAllSocials.filter((social) => social !== channel.title)])
                            } else {
                              setMobilePosts([...mobilePosts, ...calendarGridDayObjects.map((c) => ({channel:channel.title, date:c.dateString}) )])
                              setSelectedAllSocials([channel.title, ...selectedAllSocials])
                            }

                          }}
                        />
                      
                      <MyLabel sx={{ fontSize: '0.8rem', position: 'relative', top: '10px', right: '16px',
                    
                    '@media (max-width: 600px)': {
                      fontSize: '0.5rem'
                  }}} text={'Apply to all days'} />
                    </Box>


                    <Box sx={{ position: 'absolute', padding: '5px', width: '100px', display: 'none' }}><MyLabel component='p' text='update soon' sx={{ fontWeight: 500, fontStyle: 'italic' }} /></Box>
                  </Box>
                )
              })
            }
          </Box>
        </div>
        <select
          className="month-select"
          style={{ backgroundColor: 'white', position:'relative', bottom:window.innerWidth > 600 && '1rem' }}
          value={yearAndMonth[1]}
          onChange={handleMonthSelect}
        >
          {getMonthDropdownOptions(yearAndMonth[0], true).map(({ label, value }) => (
            <option value={value} key={value}>
              {label}
            </option>
          ))}
        </select>
        <select
          className="year-select"
          style={{ backgroundColor: 'white', position:'relative', bottom:window.innerWidth > 600 && '1rem' }}
          value={yearAndMonth[0]}
          onChange={handleYearSelect}
        >
          {getYearDropdownOptions(yearAndMonth[0], true).map(({ label, value }) => (
            <option value={value} key={value}>
              {label}
            </option>
          ))}
        </select>

        <div className="days-of-week" style={{position:'relative', bottom:window.innerWidth > 600 && '1rem'}}>
          {daysOfWeekFormatted.map((day, index) => (
            <div
              key={`${day}-${index}`}
              className={classNames("day-of-week-header-cell", {
                "weekend-day": [6, 0].includes(index)
              })}
            >
              {day.toUpperCase()}
            </div>
          ))}
        </div>
        <div className={window.innerWidth < 600 ? "days-grid-mobile-auto" : "days-grid"} style={{position:'relative', bottom:window.innerWidth > 600 && '1rem', height: window.innerWidth < 600 && '18rem'}}> 
          {calendarGridDayObjects.map((day) => {
            return day.isCurrentMonth && <div
              key={day.dateString}
              className={classNames("day-grid-item-container", {
                "weekend-day": isWeekendDay(day.dateString),
                "current-month": day.isCurrentMonth
              })}
           style={{
            height:'12vh'
           }}
            >
              <div className="day-content-wrapper">{<RenderDay mobilePostsActive={mobilePostsActive} mobilePosts={mobilePosts} daysSelected={daysSelected} setMobilePostsActive={setMobilePostsActive} selectedOneChannels={selectedOneChannels} handleSelectOneChannel={handleSelectOneChannel} selectedAllSocials={selectedAllSocials} calendarDayObject={day} channelsFiltered={channelsFiltered} />}</div>
            </div>
          })}

        </div>

      </div>
      {window.innerWidth < 600 && mobilePostsActive &&
      channelsFiltered.map((channel) => {
        return <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent:'space-between', borderBottom:'1px solid grey', paddingTop:'14px', paddingLeft:'7px' }}>
       
        <MyImage sx={{ marginTop: '20px',  width:'80px',  position:'relative', bottom:'20px'
      
      }} src={imgsMapped[channel.title]} />

    <MyCheckbox
    size='small'
    checked={mobilePosts.some(({date, channel:ch}) => date === mobilePostsActive && channel.title === ch)}
    value={channel}
    onChange={(event) => {
      const mobilePostsContain = mobilePosts.find(({date, channel:ch}) => ch === channel.title && date === mobilePostsActive)
      
      if(mobilePostsContain){
        setMobilePosts(mobilePosts.filter(({channel:ch, date}) => {
          return ch !== channel.title || date !== mobilePostsActive
        }))
        setSelectedAllSocials([...selectedAllSocials.filter((social) => social !== channel.title)])
      }else{
        setMobilePosts([...mobilePosts, {channel:channel.title, date:mobilePostsActive}])
      }
      
    }}
    />
      </Box>
      })
        
      }
      <Box sx={{ justifyContent: 'center', display: 'flex' }}>
        <MyButton
          sx={{
            height: '25pt',
            width: '70pt',
            marginRight: '10px',
            backgroundColor: '#6366F1',
            textTransform: 'capitalize !important',
            '@media (max-width: 600px)': {
              marginTop:'1rem'
          }

          }}

          text='Next'
          variant="contained"
          size="large"
          onClick={() => {
            setGenerateModal(true)}}
        />

      </Box>

    </MyDialog> : <MyModal 
      fullScreen={window.innerWidth < 600}
        notClose={true} 
        sx={{ position: 'absolute', height:'100vh', overflow: 'auto', left: '15%', top: window.innerWidth < 600 && '2rem',  width: window.innerWidth < 600 ? '95vh' : '70vw',
              '@media (max-width: 600px)': {
                width: '100vw',
                left: '0',
                
                float: 'left',
                height:'100vh',
                overflow:'auto'
            }
    }} title="Post" isOpen={autoCompleteOpen} setIsOpen={() => setAutoCompleteOpen(false)}>

      {
        generateModal && <MyModal 
        fullScreen={window.innerWidth < 600}
                              notClose={true} 
                              sx={{ position: 'absolute', overflow: 'auto', height: state.isGenerateModal.value ? window.innerWidth < 600 ? '500px' : '300px' : '100%', left: state.isGenerateModal.value ? window.innerWidth < 600 ? '0' : '32%' : window.innerWidth < 600 ? '0' :'20%', top: window.innerWidth > 600 ? '10%' : state.isGenerateModal.value ? '15%' : '1rem', width: state.isGenerateModal.value ? window.innerWidth < 600 ? 300 : 550 : window.innerWidth < 600 ? '100%' :'60vw', }} 
                              title="Post" 
                              isOpen={autoCompleteOpen} 
                              setIsOpen={() => setGenerateModal(false)}> 
                              <GenerateModal 
                                setIsGenerateModal={state.isGenerateModal.value} 
                                daysSelected={daysSelected} 
                                state={state}
                                profileSelected={profileSelected}
                                /> 
                          </MyModal>
       }
      

      <div className="calendar-root-autocomplete" >
        <div className="navigation-header" style={{bottom:window.innerWidth > 600 && '1rem', position:'relative'}}>

          <Box sx={{ display: 'flex', margin:0, flexDirection: 'row', justifyContent:'space-around', width: '100%',
          '@media (max-width: 600px)': {
            width: '350px',
            justifyContent: 'left',
            flexWrap:'wrap'
        }
         }}>
            {
              channelsFiltered.map((channel, key) => {
                let sx = { height: '40px', width: '40px' };

                if (!channel.active) {
                  sx = { ...sx, opacity: '0.3' };
                }

                return (
                  <Box sx={{ margin: 0, position: 'relative' }} key={key}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', }}>
                      <SocialIcon sx={{ 
                        width:'25px', 
                     }} icon={channel.icon} linked={true} />
                      <MyImage sx={{ marginLeft: '20px', 
                     width:'60px', 
                    '@media (max-width: 600px)': {
                      width:'35px', 
                      
                  }}} src={imgsMapped[channel.title]} />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', marginLeft: '5px', width:'100%', position: 'relative', bottom: '5px', }}>
                      
                        <MyCheckbox
                          
                          size='small'
                          checked={currentMonthDays.map(({ dateString }) => dateString).every((day) => {
                            return daysSelected[channel.title]?.includes(day) || moment(day).isBefore(today)
                          })}
                          value={null}
                          onChange={(e) => {
                            
                            handleSelectAllChannelDays(channel.title)
                            if (selectedAllSocials.includes(channel.title)) {
                              setSelectedOneChannels([...selectedOneChannels.filter((selectedOneChannel) => selectedOneChannel.channel !== channel.title)])
                              setMobilePosts([...mobilePosts.filter((mobilePost) => mobilePost.channel !== channel.title)])
                              setSelectedAllSocials([...selectedAllSocials.filter((social) => social !== channel.title)])
                            } else {
                              setMobilePosts([...mobilePosts, ...calendarGridDayObjects.map((c) => ({channel:channel.title, date:c.dateString}) )])
                              setSelectedAllSocials([channel.title, ...selectedAllSocials])
                            }

                          }}
                        />
                      
                      <MyLabel sx={{ fontSize: '0.8rem', position: 'relative', top: '10px', right: '16px',
                    
                    '@media (max-width: 600px)': {
                      fontSize: '0.5rem'
                  }}} text={'Apply to all days'} />
                    </Box>


                    <Box sx={{ position: 'absolute', padding: '5px', width: '100px', display: 'none' }}><MyLabel component='p' text='update soon' sx={{ fontWeight: 500, fontStyle: 'italic' }} /></Box>
                  </Box>
                )
              })
            }
          </Box>
        </div>
        <select
          className="month-select"
          style={{ backgroundColor: 'white', position:'relative', bottom:window.innerWidth > 600 && '1rem' }}
          value={yearAndMonth[1]}
          onChange={handleMonthSelect}
        >
          {getMonthDropdownOptions(yearAndMonth[0], true).map(({ label, value }) => (
            <option value={value} key={value}>
              {label}
            </option>
          ))}
        </select>
        <select
          className="year-select"
          style={{ backgroundColor: 'white', position:'relative', bottom:window.innerWidth > 600 && '1rem' }}
          value={yearAndMonth[0]}
          onChange={handleYearSelect}
        >
          {getYearDropdownOptions(yearAndMonth[0], true).map(({ label, value }) => (
            <option value={value} key={value}>
              {label}
            </option>
          ))}
        </select>

        <div className="days-of-week" style={{position:'relative', bottom:window.innerWidth > 600 && '1rem'}}>
          {daysOfWeekFormatted.map((day, index) => (
            <div
              key={`${day}-${index}`}
              className={classNames("day-of-week-header-cell", {
                "weekend-day": [6, 0].includes(index)
              })}
            >
              {day.toUpperCase()}
            </div>
          ))}
        </div>
        <div className={window.innerWidth < 600 ? "days-grid-mobile-auto" : "days-grid"} style={{position:'relative', bottom:window.innerWidth > 600 && '1rem', height: window.innerWidth < 600 && '18rem'}}> 
          {calendarGridDayObjects.map((day) => {
            return day.isCurrentMonth && <div
              key={day.dateString}
              className={classNames("day-grid-item-container", {
                "weekend-day": isWeekendDay(day.dateString),
                "current-month": day.isCurrentMonth
              })}
           style={{
            height:'12vh'
           }}
            >
              <div className="day-content-wrapper">{<RenderDay mobilePostsActive={mobilePostsActive} mobilePosts={mobilePosts} daysSelected={daysSelected} setMobilePostsActive={setMobilePostsActive} selectedOneChannels={selectedOneChannels} handleSelectOneChannel={handleSelectOneChannel} selectedAllSocials={selectedAllSocials} calendarDayObject={day} channelsFiltered={channelsFiltered} />}</div>
            </div>
          })}

        </div>

      </div>
      {window.innerWidth < 600 && mobilePostsActive &&
      channelsFiltered.map((channel) => {
        return <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent:'space-between', borderBottom:'1px solid grey', paddingTop:'14px', paddingLeft:'7px' }}>
       
        <MyImage sx={{ marginTop: '20px',  width:'80px',  position:'relative', bottom:'20px'
      
      }} src={imgsMapped[channel.title]} />

    <MyCheckbox
    size='small'
    checked={mobilePosts.some(({date, channel:ch}) => date === mobilePostsActive && channel.title === ch)}
    value={channel}
    onChange={(event) => {
      const mobilePostsContain = mobilePosts.find(({date, channel:ch}) => ch === channel.title && date === mobilePostsActive)
      
      if(mobilePostsContain){
        setMobilePosts(mobilePosts.filter(({channel:ch, date}) => {
          return ch !== channel.title || date !== mobilePostsActive
        }))
        setSelectedAllSocials([...selectedAllSocials.filter((social) => social !== channel.title)])
      }else{
        setMobilePosts([...mobilePosts, {channel:channel.title, date:mobilePostsActive}])
      }
      
    }}
    />
      </Box>
      })
        
      }
      <Box sx={{ justifyContent: 'center', display: 'flex' }}>
        <MyButton
          sx={{
            height: '25pt',
            width: '70pt',
            marginRight: '10px',
            backgroundColor: '#6366F1',
            textTransform: 'capitalize !important',
            '@media (max-width: 600px)': {
              marginTop:'1rem'
          }

          }}

          text='Next'
          variant="contained"
          size="large"
          onClick={() => {
            setGenerateModal(true)}}
        />

      </Box>
</MyModal>
  );
}